import axios from 'axios'

class HTTP {
  constructor (baseURL, agent) {
    this.agent = agent.toString()
    this.baseURL = baseURL
  }
  setLanguage (l) {
    this.language = l
  }
  _baseURL (data) {
    if (data.baseURL) return data.baseURL
    if (this.baseURL) return this.baseURL
    return ''
  }
  async send (data) {
    // Add base url
    data.url = this._baseURL(data) + data.url

    // Add headers
    let headers = { 'X-Narative-Agent': this.agent }
    if (this.language) headers['Accept-Language'] = this.language
    data = {
      ...data,
      headers: {
        ...headers,
        ...data.headers
      }
    }

    // Send
    try {
      return await axios(data)
    } catch (err) {
      // Update error
      err.isHTTP = true
      if (err.response) {
        if (err.response.data.code) err.code = err.response.data.code
        if (err.response.data.message) err.message = err.response.data.message
        if (err.response.data.messages) err.messages = err.response.data.messages
      }

      // Set toString
      const d = err.toString()
      err.toString = () => {
        if (err.code) {
          return 'Error with code ' + this.code
        } else if (err.message) {
          return err.message
        } else if (err.messages) {
          var msgs = []
          for (var [, v] of Object.entries(err.messages)) {
            msgs.push(v)
          }
          return msgs.join(' | ')
        } else return d
      }
      return Promise.reject(err)
    }
  }
}

export default HTTP
